import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../auth/auth0-provider';

/**
 * Shown when the backend refuses to create a new user account because
 * INVITE_ONLY_MODE is enabled and the signup email has no matching
 * invitation. The user's Auth0 session is still alive; they can either
 * log out or close the tab.
 */
const InviteOnly: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-surface rounded-2xl p-8 text-center">
        <h1 className="text-2xl font-bold text-foreground mb-2">
          Landing is invite-only right now
        </h1>
        <p className="text-sm text-muted-foreground mb-6">
          If you have an invitation link, use it to sign up. Otherwise, check back later.
        </p>
        <Button variant="primary" size="default" onClick={() => void logout()}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default InviteOnly;
